import { useMemo } from "react"
import { AxiosResponse } from "axios"
import { useAuthedAxios } from "hooks/core/useAuthedAxios"
import { checkDatamap, getDatamapText, reimportData, saveDatamapText } from "api/Repos/datamap"
import { DatamapCheckResponse } from "types/datamap.types"

interface UseDatamapEditorReturn {
  loadDatamap: (id: string, owner: string) => Promise<{ text: string; encoding: "utf-8" | "windows-1252" }>
  saveDatamap: (id: string, owner: string, csv: string) => Promise<void>
  checkDatamap: (id: string, owner: string, csv?: string) => Promise<DatamapCheckResponse>
  reimport: (id: string, owner: string) => Promise<AxiosResponse<unknown>>
}

/** The datamap editor's server calls. The editor owns its loading state, so these are plain async commands. */
export const useDatamapEditor = (): UseDatamapEditorReturn => {
  const getAxios = useAuthedAxios()
  return useMemo(
    () => ({
      loadDatamap: async (id: string, owner: string) => getDatamapText(await getAxios(), id, owner),
      saveDatamap: async (id: string, owner: string, csv: string) => saveDatamapText(await getAxios(), id, owner, csv),
      checkDatamap: async (id: string, owner: string, csv?: string) => checkDatamap(await getAxios(), id, owner, csv),
      reimport: async (id: string, owner: string) => reimportData(await getAxios(), id, owner),
    }),
    [getAxios]
  )
}
